function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPromotion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E9F2F4"
    },
    d: "M503.916,229.053c0,83.343-67.562,150.905-150.905,150.905s-150.905-67.562-150.905-150.905 S269.668,78.147,353.01,78.147S503.916,145.71,503.916,229.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CFDFE2"
    },
    d: "M439.242,229.053c0,47.625-38.607,86.232-86.232,86.232s-86.232-38.607-86.232-86.232 s38.607-86.232,86.232-86.232S439.242,181.428,439.242,229.053z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF5243"
    },
    d: "M191.326,476.968h-57.961c-10.195,0-18.996-7.141-21.095-17.117L72.758,272.168h140.126V455.41 C212.884,467.317,203.233,476.968,191.326,476.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AD3A2D"
    },
    d: "M191.326,476.968h-4.066c-10.195,0-18.996-7.141-21.095-17.117l-39.512-187.683h86.232V455.41 C212.884,467.317,203.233,476.968,191.326,476.968z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC8059"
    },
    d: "M148.211,293.726H72.758c-35.718,0-64.674-28.955-64.674-64.674l0,0 c0-35.718,28.955-64.674,64.674-64.674h75.453V293.726z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF997D"
    },
    d: "M148.211,239.832H78.147c-20.836,0-37.726-16.891-37.726-37.726l0,0 c0-20.836,16.891-37.726,37.726-37.726h70.063V239.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FED766"
    },
    d: "M320.674,83.068v291.969h-10.779l-153.493-50.052c-17.742-5.785-29.749-22.33-29.749-40.991V174.111 c0-18.662,12.007-35.206,29.749-40.991l153.493-50.052H320.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFDE8A"
    },
    d: "M320.674,83.068v205.738h-10.779l-108.16-35.27c-12.503-4.077-20.963-15.734-20.963-28.885v-77.428 c0-13.15,8.46-24.808,20.963-28.884l108.16-35.27H320.674z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FC8059"
    },
    d: "M309.895,390.737V67.368c0-17.86,14.477-32.337,32.337-32.337l0,0 c17.86,0,32.337,14.477,32.337,32.337v323.368c0,17.86-14.477,32.337-32.337,32.337l0,0 C324.372,423.074,309.895,408.596,309.895,390.737z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BF5243"
    },
    d: "M342.232,423.074c-17.86,0-32.337-14.477-32.337-32.337V67.368c0-17.859,14.477-32.337,32.337-32.337 V423.074z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4C4C4C"
    },
    d: "M512,229.053c0,32.826-9.923,64.337-28.698,91.127c-18.346,26.18-43.765,46.03-73.508,57.409 c-0.951,0.363-1.926,0.536-2.888,0.536c-3.253,0-6.32-1.978-7.552-5.198c-1.594-4.17,0.493-8.844,4.662-10.439 c54.918-21.006,91.815-74.63,91.815-133.435s-36.897-112.429-91.815-133.435c-4.169-1.594-6.257-6.268-4.662-10.439 c1.595-4.171,6.271-6.256,10.439-4.662c29.745,11.378,55.163,31.229,73.508,57.409C502.077,164.715,512,196.226,512,229.053z  M382.653,67.368v323.368c0,22.289-18.132,40.421-40.421,40.421s-40.421-18.132-40.421-40.421v-9.833l-74.602-24.326v98.832 c0,16.344-13.298,29.642-29.642,29.642h-57.959c-13.937,0-26.136-9.898-29.006-23.536L76.977,301.811h-4.219 C32.639,301.811,0,269.172,0,229.053s32.639-72.758,72.758-72.758h48.988c5.313-14.365,16.933-25.897,32.148-30.861l147.916-48.233 v-9.833c0-22.289,18.132-40.421,40.421-40.421S382.653,45.08,382.653,67.368z M83.708,285.642h34.886 c-0.018-0.548-0.026-1.098-0.026-1.648V174.111c0-0.551,0.009-1.101,0.026-1.648H72.758c-31.203,0-56.589,25.387-56.589,56.589 s25.387,56.589,56.589,56.589h10.623C83.49,285.64,83.599,285.64,83.708,285.642z M211.04,351.305l-57.146-18.634 c-15.216-4.963-26.835-16.496-32.148-30.861H93.5l32.921,156.376c1.305,6.199,6.85,10.698,13.185,10.698h57.959 c7.43,0,13.474-6.044,13.474-13.474V351.305H211.04z M301.811,94.207l-142.903,46.598c-14.457,4.716-24.171,18.1-24.171,33.306 v109.882c0,15.206,9.714,28.59,24.171,33.305l142.903,46.601V94.207z M366.484,67.368c0-13.372-10.88-24.253-24.253-24.253 s-24.253,10.88-24.253,24.253v15.515c0.003,0.125,0.003,0.249,0,0.374V374.85c0.003,0.124,0.003,0.248,0,0.374v15.513 c0,13.372,10.88,24.253,24.253,24.253s24.253-10.88,24.253-24.253V67.368z M412.627,290.039c-3.483,2.793-4.042,7.882-1.248,11.364 c1.596,1.992,3.943,3.027,6.311,3.027c1.774,0,3.561-0.581,5.053-1.777c22.473-18.023,35.362-44.85,35.362-73.6 s-12.889-55.576-35.364-73.599c-3.482-2.795-8.57-2.233-11.364,1.248c-2.794,3.483-2.234,8.571,1.248,11.364 c18.628,14.939,29.311,37.167,29.311,60.986S431.254,275.1,412.627,290.039z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromotion);
export default __webpack_public_path__ + "static/media/Promotion.a16e3a2652d06382ac9cffb5279bd0af.svg";
export { ForwardRef as ReactComponent };